import useSWR from 'swr';
import { DGetSelfMedicationContact } from '../data/dtos/contact';
import { selfMedicationChatService } from '../services/self-medication';

export function useSelfMedicationContact({
  userId,
}: Nullable<DGetSelfMedicationContact>) {
  const execute = async () => {
    return await selfMedicationChatService.getUserContact({
      userId: userId!,
    });
  };

  const fetchKey = userId ? ['get-self-medication-contact', userId] : null;
  const { data, isLoading, error } = useSWR(fetchKey, execute);

  return {
    data,
    error,
    isLoading,
  };
}
